import React from "react";

import { BarLoaderProps } from "@models/shared/shared.model";

const BarLoader: React.FC<BarLoaderProps> = ({
  bars = 3,
  color = "var(--light-blue)",
}) => {
  return (
    <span className="fg-bar-loader">
      <span className=" fg-loader-badge">
        {Array.from({ length: bars }).map((_, i) => (
          <span key={i} style={{ backgroundColor: color }} />
        ))}
      </span>
    </span>
  );
};

export default BarLoader;
